var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedDownvote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.63587 15.5303C5.92876 15.8232 6.40363 15.8232 6.69653 15.5303L11.4695 10.7574C11.7624 10.4645 11.7624 9.98959 11.4695 9.6967C11.1766 9.40381 10.7017 9.40381 10.4088 9.6967L6.1662 13.9393L1.92356 9.6967C1.63066 9.40381 1.15579 9.4038 0.862897 9.6967C0.570004 9.98959 0.570004 10.4645 0.862897 10.7574L5.63587 15.5303ZM5.4162 -1.47668e-07L5.4162 15L6.9162 15L6.9162 1.47668e-07L5.4162 -1.47668e-07Z",
    fill: "#CA222C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedDownvote);
export default __webpack_public_path__ + "static/media/redDownvote.e816b872f1ddf70c93d21ae09a1583a9.svg";
export { ForwardRef as ReactComponent };